export default __webpack_public_path__ + "media/images/icon-email-0df3c705dcfaa57f6209d3b083bb2bfb.svg";